export type ReCaptchaV2Submitted = Action<'RECAPTCHA_V2_SUBMITTED', string>;

export const recaptchaV2Submitted = (token: string) => ({
  type: 'RECAPTCHA_V2_SUBMITTED',
  payload: token
});

export type ActionTypes = ReCaptchaV2Submitted;

